import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch,useSelector  } from 'react-redux';
import { useInitializeAuthentication } from './useInitializeAuthentication.js';
import { useInitializeCredentials } from './useInitializeCredentials.js';
import APP_URLS from '../../urls';

export function useHospitalAuth(fetchData = false, linkToUrl = false) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Initialize authentication/credentials from localStorage if needed.
  useInitializeAuthentication();
  useInitializeCredentials();

  // Retrieve auth state and hospital data from Redux.
  const hospitalAuth = useSelector((state) => state.hospitalAuth || {});
  const hospitalData = useSelector((state) => state.hospitalData || {});
  
  // Safely destructure values with defaults
  const isAuthenticated = hospitalAuth.isAuthenticated || false;
  const credentials = hospitalAuth.credentials;
  const hospitalAuthData = hospitalAuth.hospital || {};
  const hospitalProfileData = hospitalData.hospital || {};

  // Rest of your code remains the same
  useEffect(() => {
    if (fetchData && credentials) {
      dispatch(fetchHospitalData());
    }
  }, [fetchData, credentials, dispatch]);

  useEffect(() => {
    if (!isAuthenticated && linkToUrl) {
      navigate('/app/hospital/dashboard');
    }
  }, [isAuthenticated, linkToUrl, navigate]);

  return {
    isAuthenticated,
    credentials,
    hospitalData: { ...hospitalProfileData, ...hospitalAuthData }
  };
}
